import { component } from 'picoapp'
import { zelektor, toggleBtn, disableBtn, enableBtn } from '@/lib/utility-functions.js'
import getProductJSON from '@/lib/get-product-json.js'
import options from '@/lib/options.js'
import updatePrices from '@/lib/update-prices.js'
import { addVariant } from '@/lib/cart.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const product = getProductJSON()
    const { selectedOrFirstAvailableVariant } = JSON.parse(document.querySelector('.js-productJSON').innerHTML)
    const { decrease, increase, qty, form, variantSelect, submit, sizeSelection, sizeSelectionTitle } = zelektor(node)

    /*******************************************************************************************************************************************/
    /* Option Selection
    /*******************************************************************************************************************************************/
    const opts = options(ctx.node)

    opts.onUpdate((state) => {
        const variant = state.id != undefined ? product.variants.filter((v) => v.id == state.id)[0] : null

        if (variant) {
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`)
            updatePrices(variant, node)
            updateSubmit(true, variant.available)
            unfocusSizeSelection()
        } else {
            updateSubmit(false, false)
        }
    })

    function updateSubmit(variantExists, isAvailable) {
        const disabledText = variantExists ? theme.strings.product.soldOut : theme.strings.product.unavailable
        submit.disabled = !isAvailable

        if (isAvailable) {
            toggleBtn(submit, true, theme.strings.product.addToCart)
            submit.classList.remove('is-disabled')
        } else {
            toggleBtn(submit, false, disabledText)
            submit.classList.add('is-disabled')
        }
    }

    function unfocusSizeSelection() {
        sizeSelection.classList.remove('is-focused')

        const title = theme.strings.product.size
        if (title.length && sizeSelectionTitle) sizeSelectionTitle.innerText = title
    }

    /*******************************************************************************************************************************************/
    /* Quantity Selection
    /*******************************************************************************************************************************************/
    decrease.addEventListener('click', handleControl)
    increase.addEventListener('click', handleControl)

    function handleControl(e) {
        const currentVal = parseInt(qty.value)
        let newVal

        e.currentTarget === decrease ? (newVal = currentVal - 1) : (newVal = currentVal + 1)
        qty.value = Math.max(qty.min, newVal)

        qty.value === qty.min ? disableBtn(decrease) : enableBtn(decrease)
    }

    /*******************************************************************************************************************************************/
    /* Add To Cart
    /*******************************************************************************************************************************************/
    let currentVariant = product.variants.find((variant) => variant.id === selectedOrFirstAvailableVariant)
    updatePrices(currentVariant, node)

    submit.addEventListener('click', submitForm)

    function submitForm(e) {
        e.preventDefault()

        variantSelect.selectedIndex > -1 ? addToCart(e, form) : focusSizeSelection()
    }

    function focusSizeSelection() {
        sizeSelection.classList.add('is-focused')

        const title = theme.strings.product.selectSize
        if (title.length) sizeSelectionTitle.innerText = title
    }

    function addToCart(e, form) {
        toggleBtn(submit, true, theme.strings.product.addingToCart)

        currentVariant = product.variants.find((variant) => variant.id === parseInt(variantSelect.value))
        const qtyValue = parseInt(qty.value)

        addVariant({
            variant: currentVariant,
            qty: qtyValue,
            callback: () => {
                toggleBtn(submit, false, theme.strings.product.addToCart)
            },
        })
    }
})
